import React from 'react';
import { APP_NAME } from '../constants';
import ChatBackdrop from './ChatBackdrop';
import ChatFooter from './ChatFooter';
import ChatHeader from './ChatHeader';
import ChatInputForm from './ChatInputForm';
import ChatMessageList from './ChatMessageList';
import ChatScrollButton from './ChatScrollButton';

export default function ChatWindow({
  onClose,
  onReset,
  messages,
  showWelcome,
  isLoading,
  onSend,
  scroll,
  input
}) {
  return (
    <>
      <ChatBackdrop onClose={onClose} />
      <div className="chatbox-window" role="dialog" aria-label={APP_NAME}>
        <ChatHeader onReset={() => onReset()} onClose={onClose} />

        <div className="chatbox-container">
          <ChatMessageList
            messages={messages}
            showWelcome={showWelcome}
            isLoading={isLoading}
            onQuickPrompt={onSend}
            messagesContainerRef={scroll.messagesContainerRef}
            messagesEndRef={scroll.messagesEndRef}
            onScroll={scroll.handleMessagesScroll}
          />

          {scroll.showScrollBtn && (
            <ChatScrollButton onClick={() => scroll.scrollToBottom()} />
          )}

          <ChatInputForm
            inputRef={input.inputRef}
            value={input.inputMessage}
            onChange={(e) => input.setInputMessage(e.target.value)}
            onSubmit={input.handleSend}
            onKeyDown={input.handleInputKeyDown}
            disabled={isLoading}
            canSend={input.canSend}
          />

          <ChatFooter />
        </div>
      </div>
    </>
  );
}
